import { apiClient } from './apiClient';

let cachedSettings = null;
let inFlight = null;
let cachedAt = 0;
let cachedFooterSettings = null;
let footerInFlight = null;
let footerCachedAt = 0;
let cachedCatalogSettings = null;
let catalogInFlight = null;
let catalogCachedAt = 0;
let cachedCategories = null;
let categoriesInFlight = null;
let categoriesCachedAt = 0;

const DEFAULT_TTL_MS = 60000; // 1 minute cache TTL

export async function getSettings({ force = false, ttlMs = DEFAULT_TTL_MS } = {}) {
  const now = Date.now();
  const isFresh = cachedSettings && now - cachedAt < ttlMs;

  if (!force && isFresh) return cachedSettings;

  if (!force && inFlight) return inFlight;

  inFlight = apiClient
    .get('/settings')
    .then((data) => {
      cachedSettings = data;
      cachedAt = Date.now();
      return data;
    })
    .catch(() => null)
    .finally(() => {
      inFlight = null;
    });

  return inFlight;
}

export async function getFooterSettings({ force = false, ttlMs = DEFAULT_TTL_MS } = {}) {
  const now = Date.now();
  const isFresh = cachedFooterSettings && now - footerCachedAt < ttlMs;

  if (!force && isFresh) return cachedFooterSettings;

  if (!force && footerInFlight) return footerInFlight;

  footerInFlight = apiClient
    .get('/settings/footer')
    .then((data) => {
      cachedFooterSettings = data;
      footerCachedAt = Date.now();
      return data;
    })
    .catch(() => null)
    .finally(() => {
      footerInFlight = null;
    });

  return footerInFlight;
}

export async function getCatalogSettings({ force = false, ttlMs = DEFAULT_TTL_MS } = {}) {
  const now = Date.now();
  const isFresh = cachedCatalogSettings && now - catalogCachedAt < ttlMs;

  if (!force && isFresh) return cachedCatalogSettings;

  if (!force && catalogInFlight) return catalogInFlight;

  catalogInFlight = apiClient
    .get('/settings/catalog')
    .then((data) => {
      cachedCatalogSettings = data;
      catalogCachedAt = Date.now();
      return data;
    })
    .catch(() => null)
    .finally(() => {
      catalogInFlight = null;
    });

  return catalogInFlight;
}

export async function getCategories({ force = false, ttlMs = DEFAULT_TTL_MS } = {}) {
  const now = Date.now();
  const isFresh = cachedCategories && now - categoriesCachedAt < ttlMs;

  if (!force && isFresh) return cachedCategories;

  if (!force && categoriesInFlight) return categoriesInFlight;

  categoriesInFlight = apiClient
    .get('/categories', { unwrap: true })
    .then((data) => {
      cachedCategories = data;
      categoriesCachedAt = Date.now();
      return data;
    })
    .catch(() => null)
    .finally(() => {
      categoriesInFlight = null;
    });

  return categoriesInFlight;
}

export function clearSettingsCache() {
  cachedSettings = null;
  cachedAt = 0;
  inFlight = null;
  cachedFooterSettings = null;
  footerCachedAt = 0;
  footerInFlight = null;
  cachedCatalogSettings = null;
  catalogCachedAt = 0;
  catalogInFlight = null;
  cachedCategories = null;
  categoriesCachedAt = 0;
  categoriesInFlight = null;
}
